<script>
	let form = {};
	let submited = false;
	let error = "";
</script>
<div class="">
	{#if submited}
		<p>
			Thankyou for contacting us. We will get back to you ASAP.
		</p>
	{:else}
		<form class="context-box" on:submit|preventDefault={e => {
			error = "";
			fetch("https://crm.lamara.in/products/customerapi/savecontact", {
				method: 'POST',
				body: JSON.stringify(form)
			}).then(res => res.json()).then(res => {
				if(!resizeBy.error){
					submited = true;
				}else{
					error = res.error;
				}
			})
		}}>
			<div class="form-row">
				<div class="col-md-12 form-group">
					{#if error}
						<div class="form-group">
							<p class="text-danger">{error}</p>
						</div>
					{/if}
					<div class="form-group">
						<label for="name">Name:</label>
						<input type="text" class="form-control" placeholder="Enter name" bind:value={form.name} required>
					</div>
					<div class="form-group">
						<label for="exampleInputPassword1">Mobile:</label>
						<input type="tel" class="form-control" maxlength="13" placeholder="Mobile number" bind:value={form.phone_num} required>
					</div>
					<div class="form-group">
						<label for="email">Email address:</label>
						<input type="email" class="form-control" id="email" placeholder="Enter email" bind:value={form.email_id} required>
					</div>
					<div class="form-group">
						<label for="exampleInputEmail1">Comments:</label>
						<textarea class="form-control" placeholder="Enter message" bind:value={form.message} required/>
					</div>
				</div>
			</div>
			<hr class="mb-4">
			<button class="btn btn-primary bt-lg btn-block" type="submit">Submit</button>
		</form>
	{/if}
</div>
<style lang="scss">
	.section-title{
		padding: 6em 0 1em 0;
	}

	.form-page {
		padding-top: 100px;
		padding-bottom: 100px;
		min-height: 74vh;
	}

	.invalid-feedback{
		display: block;
	}

	label {
		font-family: var(--primary-font);
		font-size: 16px;
	}

	h4:focus {
		outline: none;
	}

	h4 {
		font-size: 24px;
		font-family: var(--primary-font);
		font-weight: 600;
	}

	.content-box {
		padding: 24px 24px;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		color: #444;
		box-shadow: 8px 8px 8px #888888;
	}
</style>